/**
 * Utility functions for prefetching route chunks
 * This helps improve perceived performance by loading chunks before they're needed
 */

// Prefetch home page chunk (handles redirect logic)
export const prefetchHome = () => {
  import('../pages/HomePage');
};

// Prefetch dashboard chunk when user hovers over dashboard link
export const prefetchDashboard = () => {
  import('../pages/DashboardPage');
};

// Prefetch conversations chunk
export const prefetchConversations = () => {
  import('../pages/ConversationsPage');
};

// Prefetch reports chunk
export const prefetchReports = () => {
  import('../pages/ReportsPage');
};

// Prefetch admin chunk
export const prefetchAdmin = () => {
  import('../pages/AdminPage');
};

// Prefetch app detail chunk
export const prefetchAppDetail = () => {
  import('../pages/AppDetailPage');
};

// Prefetch customers chunk
export const prefetchCustomers = () => {
  import('../pages/CustomersPage');
};

// Prefetch profile chunk
export const prefetchProfile = () => {
  import('../pages/Profile');
};

// Prefetch platform admin chunk
export const prefetchPlatformAdmin = () => {
  import('../pages/PlatformAdmin');
};

// Prefetch billing setup chunk
export const prefetchBillingSetup = () => {
  import('../pages/billing/BillingSetup').then(module => ({ default: module.BillingSetup }));
};

// Prefetch platform company detail chunk
export const prefetchPlatformCompany = () => {
  import('../pages/PlatformCompany');
};

// Prefetch platform app detail chunk
export const prefetchPlatformApp = () => {
  import('../pages/PlatformApp');
};

// Prefetch all major routes (use sparingly, e.g., after login)
export const prefetchAllRoutes = () => {
  // Use setTimeout to avoid blocking the main thread
  setTimeout(() => {
    prefetchDashboard();
    prefetchConversations();
  }, 1000);
  
  // Lower priority routes
  setTimeout(() => {
    prefetchReports();
    prefetchAdmin();
  }, 3000);
};